import api from "../api/api";

const normalizeContactsResponse = (response) => {
  if (!response?.data) return [];
  if (Array.isArray(response.data)) return response.data;
  if (Array.isArray(response.data.data)) return response.data.data;
  return [];
};

export const ContactServices = {
  // Get all contacts
  getAllContacts: async () => {
    const res = await api.get("/contacts");
    return normalizeContactsResponse(res);
  },

  // Get single contact by ID
  getContactById: async (id) => {
    if (!id) throw new Error("Contact ID is required");
    const res = await api.get(`/contacts/${id}`);
    if (res?.data?.status && res.data.data) {
      return res.data.data;
    }
    return res?.data || null;
  },
};

export default ContactServices;